import React from "react";
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <div className="main-not-found-container">
      <div className="not-found-content">
        <div className="not-found-header">
          <h1>Oops!</h1>
          <p className="not-found-subheader">We couldn’t find the page you were looking for.</p>
        </div>
        <div className="not-found-body">
          <img src="/images/404-illustration.svg" alt="404" className="not-found-illustration" />
          <p className="not-found-text">
            It seems like the page you're looking for has moved, or doesn’t exist.
            <br />
            Don’t worry! Let’s get you back on track.
          </p>
        </div>
        <div className="not-found-actions">
          <a href="/" className="cta-button">Go Back to Home</a>
         </div>
      </div>
    </div>
  );
};

export default PageNotFound;
